<template>
    <div class="table-container ">
        <div class="filter-container ml-2 mt-2">
                <validated-date-picker
                    format="DD-MM-YYYY"
                    :clearable="true"
                    v-model="checkup_date"
                    label="Checkup Date"
                    class="c-input-datepicker">
                </validated-date-picker>
        </div>
        <vue-table ref="table1" :fields="fields" :url="pregnancyListURL" :per-page="10" :show-search-box="false" :extra-params="{ checkup_date: checkup_date }">
        </vue-table>
    </div>
</template>

<script>
import urls from '../../../../data/urls';
import { mapGetters } from 'vuex';

export default {
    name: 'PregnancyCheckup',
    computed: {
        ...mapGetters(['currentUser']),
        pregnancyListURL () {
            const cowID = this.$route.params.id;

            return urls.cowDetailEdit.pregnancyInfo + '?id=' + cowID;
        }
    },

    data () {
        return {
            animal: 'cow',
            id: '',
            checkup_date: '',
            fields: [
                {
                    name: 'checkup_date',
                    title: 'Checkup Date',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 b-unset w-10r fs-lg-0'
                },
                {
                    name: 'ai_date',
                    title: 'Date of AI',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 b-unset w-10r fs-lg-0'
                },
                {
                    name: 'cow_breed',
                    title: 'Breed',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 b-unset w-10r fs-lg-0'
                },
                {
                    name: 'method_used',
                    title: 'Method Used',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 b-unset w-10r fs-lg-0'
                },
                {
                    name: 'result',
                    title: 'Result',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 b-unset w-20r fs-lg-0'
                },
                {
                    name: 'remarks',
                    title: 'Remarks',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 b-unset w-20r fs-lg-0'
                }
            ],
            loading: false
        };
    },

    mounted () {
        this.id = this.$route.params.id;
    }
};
</script>

<style scoped>
.table-container {
        background-color: #fff;
        border-radius: 12px;
        padding: 10px;
    }

    .filter-container {
        width: 200px;
    }
</style>
